var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionBtn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4458_7841",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4458_7841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99997 21H8.2615L18.4981 10.7634L17.2366 9.50188L6.99997 19.7385V21ZM6.40385 22.5C6.14777 22.5 5.93311 22.4133 5.75987 22.2401C5.58662 22.0668 5.5 21.8522 5.5 21.5961V19.8635C5.5 19.6196 5.5468 19.3871 5.6404 19.1661C5.73398 18.9451 5.86282 18.7526 6.02692 18.5885L18.6904 5.93078C18.8416 5.79343 19.0086 5.68729 19.1913 5.61237C19.374 5.53746 19.5656 5.5 19.7661 5.5C19.9666 5.5 20.1608 5.53558 20.3488 5.60675C20.5368 5.6779 20.7032 5.79103 20.848 5.94615L22.0692 7.18268C22.2243 7.32754 22.3349 7.49424 22.4009 7.68278C22.4669 7.87129 22.5 8.05981 22.5 8.24833C22.5 8.44941 22.4656 8.64131 22.3969 8.82403C22.3283 9.00676 22.219 9.17373 22.0692 9.32495L9.41147 21.973C9.24738 22.1371 9.05483 22.266 8.83383 22.3596C8.61281 22.4532 8.38037 22.5 8.1365 22.5H6.40385ZM17.8563 10.1437L17.2366 9.50188L18.4981 10.7634L17.8563 10.1437Z",
    fill: "#35353A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionBtn1);
export default __webpack_public_path__ + "static/media/action-btn1.10c38a23f7c91d4e3c0686c0d2576237.svg";
export { ForwardRef as ReactComponent };